/**
* Hmr Notifications Directive
* @todo make this a class
*/
import MessageService from '../../services/message.service';
import notificationUrl from '../templates/partials/notifications.html';

function hmrNotifications(MessageService) {
    return {
        restrict: 'A',
        scope: {},
        templateUrl: notificationUrl,
        link: function (scope, elem, attr, ctrl) {
            scope.alerts = MessageService.getAll();
            scope.MessageService = MessageService;
        }
    };
}

export default angular.module('hmrNotifications', [MessageService])
    .directive('hmrNotifications', ['MessageService',hmrNotifications]).name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/hmrNotifications.directive.js
 **/